import React, { useEffect, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import ReactTableBase from "../../../../shared/components/table/ReactTableBase";
import moment from 'moment';
import { formatNumber } from '../../../Utils/Money';
import PropTypes from 'prop-types';


const RefundsList = ({
  refunds,
  receipt,
  admision,
  ReactTableActions,
  refreshList
}) =>{
  const [rows, setData] = useState(refunds);
  const [isEditable, setIsEditable] = useState(false);
  const [isResizable, setIsResizable] = useState(false);
  const [isSortable, setIsSortable] = useState(false);
  const [withSearchEngine, setWithSearchEngine] = useState(true);
  const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
  const [isDisabledEditable, setIsDisabledEditable] = useState(false);
  const [isDisabledResizable, setIsDisabledResizable] = useState(false);
  const [withDragAndDrop, setWithDragAndDrop] = useState(false);
  const [withPagination, setWithPaginationTable] = useState(true);

  useEffect(()=>{
    setData(refunds);
  },[refunds])

  const handleClickIsEditable = () => {
    if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
    setIsResizable(false);
    setIsEditable(!isEditable);
  };
  const handleClickIsResizable = () => {
    setIsEditable(false);
    setWithDragAndDrop(false);
    setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
    setIsDisabledEditable(!isDisabledEditable);
    setIsResizable(!isResizable);
  };
  const handleClickIsSortable = () => {
    setIsSortable(!isSortable);
  };
  const handleClickWithDragAndDrop = () => {
    if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
    setIsResizable(false);
    setWithDragAndDrop(!withDragAndDrop);
  };
  const handleClickWithPagination = () => {
    setWithPaginationTable(!withPagination);
  };
  const handleClickWithSearchEngine = () => {
    setWithSearchEngine(!withSearchEngine);
  };

  const updateDraggableData = (result) => {
    const items = reorder(
      rows,
      result.source.index,
      result.destination.index,
    );
    setData(items);
  };

  const tableConfig = {
    isEditable,
    isResizable,
    isSortable,
    withDragAndDrop,
    withSearchEngine,
    placeholder: "Buscar devolución",
    withPagination,
    manualPageSize: [3, 6, 9, 12, 15],
    useActions: true,
    actions: (data) => ReactTableActions({ data, receipt , admision, refreshList }),
  };

  const columnsRefunds = [
    {
      Header: "ID",
      Cell: ({ row }) => <label>{row.index + 1}</label>,
    },
    {
      Header: "Num Devolución",
      accessor: "num_devolucion_recibo",
      Cell: (row) => <label>{row.value}</label>,
    },
    {
      Header: "Fecha y Hora",
      accessor: "fecha_emision",
      Cell: (row) => (
        <label>{moment(row.value).format("DD-MM-YYYY | HH:mm")}</label>
      ),
    },
    {
      Header: "Total",
      accessor: "valor_devolucion",
      Cell: (row) => <label>${formatNumber(parseInt(row.value))}</label>,
    },
  ];

  return (
    <Col md={12} lg={12}>
    <Card>
      <CardBody>
        <div className="react-table__wrapper">

        </div>
        <ReactTableBase
          key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
          columns={columnsRefunds}
          data={rows}
          updateDraggableData={updateDraggableData}
          tableConfig={tableConfig}
        />
      </CardBody>
    </Card>
  </Col>
  );
}

RefundsList.propTypes = {
  columnsRefunds: PropTypes.arrayOf(PropTypes.shape()),

  tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
  defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};
export default RefundsList;
